<div class="h-full w-full relative">
  <google-map
    #storeMapId
    [mapId]="GOOGLE_MAP_ID"
    width="100%"
    height="100%"
    [options]="mapConfig()"
    (mapInitialized)="onMapInitialized()"
    (idle)="onBoundsChanged()"
  >
    @for (marker of markers(); track marker.position; let i = $index) {
      <map-advanced-marker [options]="marker" (mapClick)="onMarkerClick(i)" />
    }
  </google-map>
  @if (!singleStationMode()) {
    <div class="absolute top-0 left-0 right-0 z-10">
      <app-quick-filter-pills></app-quick-filter-pills>
    </div>
  }
</div>
